export default {
  '上级机构名称':'上級機構名稱',
  '本机构名称':'本機構名稱',
  '机构代码':'機構代碼',
  '管理员名称':'管理員名稱',
  '管理员账号':'管理員賬號',
  '设备激活码':'設備激活碼',
  '学制':'學制',
  '编辑机构信息':'編輯機構資訊',
  '机构名称':'機構名稱',
  '机构类型':'機構類型',
  '地图选择':'地圖選擇',
  '经纬度':'經緯度',
  '密码':'密碼',
  '选择地点':'選擇地點',
  '关键词搜索':'關鍵詞搜索',
  '请选择位置':'請選擇位置',
  '全国':'全國',
  '地址：':'地址：',
  '区域':'區域',
  '上级机构':'上級機構',
  '机构通用管理密码':'機構通用管理密碼',
  '设备部分功能的调试密码，非管理员账号的密码':'設備部分功能的調試密碼，非管理員賬號的密碼',
}    